<template>
  <form-form :initialForm="initialForm" />
</template>

<script setup>
import { useRoute } from 'vue-router'
import FormForm from './_Form.vue'

const route = useRoute()

const fullname = window.gon?.user?.fullname
const [surname, name, patronymic] = fullname.split(' ')

const initialForm = {
  id: null,
  surname: surname || null,
  name: name || null,
  patronymic: patronymic || null,
  gender: null,
  birthdate: null,
  phone: null,
  phone_country: 'RU',
  kind: route.query.kind || null,
  has_agreement: false,
}
</script>
